<input id="upload-file-input" #fileInput type="file" style="display: none" (change)="startUpload($event.target)" />
<mat-toolbar class="file-management-toolbar">
  @if (!viewContext.isManagementView()) {
    <button
      mat-stroked-button
      (click)="onClose()"
      [attr.aria-label]="'Files.Picker.CloseTip' | translate: locale.language">
      <mat-icon>close</mat-icon>
      {{ 'Files.Picker.Close' | translate: locale.language }}
    </button>
  }

  @if (viewContext.isManagementView() && !fileToUpload()) {
    <mat-button-toggle-group aria-label="Switch View Type" [disabled]="(datasource?.loading$ | async) === true">
      <mat-button-toggle
        [value]="'details'"
        [checked]="viewContext.displayType() === 'details'"
        (click)="onSwitchToDetailsView()"
        (keydown.enter)="onSwitchToDetailsView()"
        [matTooltip]="'Files.Management.DetailsView' | translate: locale.language">
        <mat-icon>space_dashboard</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle
        [value]="'table'"
        [checked]="viewContext.displayType() === 'table'"
        [routerLink]="['.']"
        [queryParams]="onSwitchToTableView()"
        [matTooltip]="'Files.Management.TableView' | translate: locale.language">
        <mat-icon>table_chart</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
    <mat-button-toggle-group aria-label="Switch File Type Filter" [disabled]="(datasource?.loading$ | async) === true">
      <mat-button-toggle
        [value]="null"
        [checked]="viewContext.fileTypes() === null"
        [routerLink]="['.']"
        [queryParams]="onSwitchFileTypes(null)">
        {{ 'Files.Management.Filters.All' | translate: locale.language }}
      </mat-button-toggle>
      <mat-button-toggle
        [value]="'image'"
        [checked]="viewContext.fileTypes() === 'image'"
        [routerLink]="['.']"
        [queryParams]="onSwitchFileTypes('image')">
        {{ 'Files.Management.Filters.Images' | translate: locale.language }}
      </mat-button-toggle>
      <mat-button-toggle
        [value]="'audio'"
        [checked]="viewContext.fileTypes() === 'audio'"
        [routerLink]="['.']"
        [queryParams]="onSwitchFileTypes('audio')">
        {{ 'Files.Management.Filters.Audio' | translate: locale.language }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  }

  <!-- <span class="spacer"></span> -->
  @if (!fileToUpload()) {
    <button
      mat-stroked-button
      (click)="fileInput.click()"
      [disabled]="(datasource?.loading$ | async) === true"
      [attr.aria-label]="viewContext.uploadButton.tip | translate: locale.language">
      <mat-icon>{{ viewContext.uploadButton.icon }}</mat-icon>
      {{ viewContext.uploadButton.label | translate: locale.language }}
    </button>
  }
</mat-toolbar>
@if (!!deleteJob()) {
  <div class="loading">
    <p>{{ 'Files.Management.DeletingFiles' | translate: locale.language }}</p>
    <mat-progress-bar mode="determinate" [value]="deleteJob().progress()"></mat-progress-bar>
  </div>
} @else if ((datasource?.loading$ | async) === true) {
  <div class="loading">
    <p>{{ 'Files.Shared.Loading' | translate: locale.language }}</p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
} @else if (uploading()) {
  <div class="loading">
    <p>{{ 'Files.Shared.Uploading' | translate: locale.language }}</p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
} @else {
  <div [style.display]="!!deleteJob() || (datasource?.loading$ | async) === true ? 'none' : 'block'">
    <ng-container *ngComponentOutlet="viewOutput.component; inputs: viewOutput.inputs"></ng-container>
  </div>
}
